import { useQuery } from "@apollo/client/react";
import { GET_INDICACION_INSUMO_DISPO } from "../../../../../data/graphQL/queries/GestionAsistencial/getIndicacionInsumosDispo";
import { adaptIndicacionInsumosDispo } from "../../../../../adapters/gestionAsistencial/adaptIndicacionInsumoDispo";
import { GET_UNIDADES } from "../../../../../data/graphQL/queries/Insumos/queries";
import { adaptUnidades } from "../../../../../adapters/gestionAsistencial/adaptUnidades";
import moment from "moment";

export function useTabIndicationAddIndicacionFields({
  idEvaluacion,
  insumosAdded = [],
  isAdding = false,
  isEditing = false,
  isShowingHistory = false
}) {

  const { data: unidades } = useQuery(GET_UNIDADES);
  const { data: insumos, loading } = useQuery(GET_INDICACION_INSUMO_DISPO, {
    variables: {
      idIndicacion: 0,
      idEvaluacion
    }
  });

  const adaptedUnidades = adaptUnidades(unidades || []);
  const adaptedInsumos = adaptIndicacionInsumosDispo(insumos || []);

  const filteredInsumos = adaptedInsumos.filter((insumo) => {
    return !insumosAdded.some((added) => added.idInsumoN === insumo.id);
  });

  const firstRowfields = [
    {
      displayName: "Desde",
      name: "fechaDesde",
      type: "date",
      col: 2.5
    },
    {
      displayName: "Hasta",
      name: "fechaHasta",
      type: "date",
      col: 2.5
    }];


  const secondRowfields = !isShowingHistory ? [
    {
      displayName: "Motivo de solicitud",
      name: "observacion",
      type: 'long_string',
      col: 12,
      disabled: isEditing
    }] :
    [];

  const searchField = isShowingHistory ?
    [
      {
        displayName: "Buscar",
        name: "insumo",
        type: "search",
        col: 6
      }] :

    [
      {
        displayName: "Buscar",
        name: "insumo",
        type: "autocomplete_complex",
        options: filteredInsumos,
        loading: loading,
        col: 5.5,
        disabled: isEditing
      }];


  const thirdRowfields = [
    ...searchField,
    {
      displayName: "Cantidad",
      name: "cantidad",
      type: "int",
      col: 2,
      disabled: isEditing
    },
    {
      displayName: "Unidad",
      name: "idUnidad",
      type: "select",
      options: adaptedUnidades,
      disabled: isEditing || isAdding,
      col: 2.5
    }];


  return { firstRowfields, secondRowfields, thirdRowfields };
}